module.exports = __webpack_public_path__ + "static/media/bgFinancing.59491c2d.jpg";